export const projects = [
  {
    title: "React Reserve",
    subtitle: "MERN Stack",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-1.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "React Tracks",
    subtitle: "React and Python",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-2.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "DevChat",
    subtitle: "React and Firebase",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-3.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "Epic Todo App",
    subtitle: "React Hooks",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-4.gif",
    link: "https://reactbootcamp.com",
  },
];

export const testimonials = [
  {
    quote:
      "Chris is a great addition to any team. As the first-born child in the family, he's demonstrated a consistent ability to learn, innovate, and set an example for his peers. He is undoubtedly the favorite of my children, none of his brothers come close.",
    image: "https://randomuser.me/api/portraits/men/8.jpg",
    name: "My Dad",
    company: "Intel",
  },
  {
    quote:
      "Chris is a hard worker and people seem to like him. Look, he's not my favorite kid, but he's not like a bad guy or anything. What is this for again?",
    image: "https://randomuser.me/api/portraits/women/4.jpg",
    name: "My Mom",
    company: "Between Jobs",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Tailwind",
  "MySQL",
  "Next.js",
  "Node",
];



// WEBPACK FOOTER //
// ./src/data.js